/* eslint-disable */
// import DownloadImage from "bam-node-evp/src/Utilities/DownloadImage";
import omit from 'lodash/omit'
import LoadSchema from '../Schema'
import SaveFile from './SaveFile'

export default function SaveImage({ data, player, options }, callback) {
    const schema = LoadSchema(data, player, options)
    schema.shapeRatio = 2
    schema.embed = options.embed
    options.appType = 'evp'

    data = data.map((d) =>
        omit(d, [
            'des',
            'on_3b',
            'on_2b',
            'on_1b',
            'sv_id',
            'play_id',
            'h_launch_speedangle_code',
            'if_fielding_alignment',
            'of_fielding_alignment',
            'pos1_int_start_distance',
            'pos4_int_start_distance',
            'pos7_int_start_distance',
            'pos2_int_start_distance',
            'pos5_int_start_distance',
            'pos8_int_start_distance',
            'pos3_int_start_distance',
            'pos6_int_start_distance',
            'pos9_int_start_distance',
        ])
    )

    fetch(`/evp/add`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow', // manual, *follow, error
        body: JSON.stringify({
            player,
            data,
            schema,
            appType: 'evp',
        }),
    })
        .then((response) => {
            if (!response.ok) {
                return { error: 'No data' }
            }
            return response.json()
        })
        .then((response) => {
            if (response.error) {
                callback(response.err)
            } else {
                // callback(null, response.id);
                if (!options.embed) {
                    SaveFile(response.id, player, schema, options, () => {
                        callback(null, response.id)
                    })
                } else {
                    callback(null, { link: response.id })
                }
            }
        })
}
